/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Warning_Cps_LabelInputs */



/**
* | output |
* | --- |
* | "CPS" |
*
* @param {Event_Warning_Cps_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_warning_cps_label = /** @type {((inputs?: Event_Warning_Cps_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Warning_Cps_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("CPS")
	if (locale === "de") return /** @type {LocalizedString} */ ("CPS")
	if (locale === "it") return /** @type {LocalizedString} */ ("CPS")
	if (locale === "ru") return /** @type {LocalizedString} */ ("CPS")
	if (locale === "es") return /** @type {LocalizedString} */ ("CPS")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("中央公共系统")
	if (locale === "ja") return /** @type {LocalizedString} */ ("児童保護サービス")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सीपी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("CPS")
	return /** @type {LocalizedString} */ ("CPS")
});